/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import "./Settings.css";
import ReusableModal from "./ReusableModal";
import { ToastContainer } from "react-toastify";
import AuthContext from "../../../../utils/secure-route/AuthContext";
import useApi from "../../../../utils/api-manager/Helper/useApi";
import BankIcon from "../../../../assets/Image/bank.png";
import duedays from "../../../../assets/Image/days.png";
import { capitalizeFirstLetter } from "../../../../utils/helper/common";
import LoadingOverlay from "../../../common/LoadingBar.js";
import loader from "../../../../assets/Image/Loader2.gif";
import { useToastHandler } from "../../../common/ToastHandler";
import useSwal from "../../../common/ReusableComponent/useSwal";
import Configuration from "./Configuration";
import ManageDepartments from "./ManageDepartments";
import ManageExpenseType from "./ManageExpenseType";
import OtherIncomeType from "./OtherIncomeType";
import PaymentTerminalSettings from "./PaymentTerminalSettings";
import POSPrinterSettings from "./POSPrinterSettings";
import POSCashDrawerSettings from "./POSCashDrawerSettings";
import InvoiceLayoutSettings from "./InvoiceLayoutSettings";
import {
  Building2,
  CalendarDays,
  CircleDollarSign,
  Landmark,
  ReceiptText,
  Settings2,
  Trash2,
  CreditCard,
  Printer,
  Inbox,
  FileText,
} from "lucide-react";
// import WebSocketData from "./WebSocketData";

const ManageSettings = () => {
  let { user } = useContext(AuthContext);
  const storeId = user.store;
  const [showModal, setShowModal] = useState(false);
  const [formType, setFormType] = useState("");
  // Initialize state properly with empty strings instead of undefined
  const [dueDaysList, setDueDaysList] = useState([]); // State for due days
  const [editingDueDayId, setEditingDueDayId] = useState(null); // ID of the editing due day
  const [dueDays, setDueDays] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [editingBankId, setEditingBankId] = useState(null);
  const [numberOfRegisters, setNumberOfRegisters] = useState(0);
  const [numberOfLotteryRegisters, setNumberOfLotteryRegisters] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedRegister, setSelectedRegister] = useState(true);
  const [selectedLotteryRegister, setSelectedLotteryRegister] = useState("");
  const [settingId, setSettingId] = useState(null);
  const [salesTax, setSalesTax] = useState(0);
  const [lotteryBookFromLastNumber, setLotteryBookFromLastNumber] = useState(true);
  const [lotteryAfterEndOfDay, setLotteryAfterEndOfDay] = useState(true);
  const [banks, setBanks] = useState([]);
  const { _Get, Post, Put, Delete, Patch, GetPaginatedData } = useApi();
  const { handleToast } = useToastHandler();
  const { confirmDelete } = useSwal();
  // Initialize checkedStates with proper values
  const [checkedStates, setCheckedStates] = useState({
    1: false,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
    7: false,
    8: false,
    9: false,
    10: false,
    11: false,
    12: false,
    13: true, // Always active
    14: true, // Always active
  });
  const [activeSettingsTab, setActiveSettingsTab] = useState("configuration");

  const settingsTabs = [
    { id: "configuration", label: "Configuration", helper: "Regional defaults", icon: Settings2 },
    { id: "banks", label: "Manage Banks", helper: "Payout accounts", icon: Landmark },
    { id: "dueDays", label: "Due Days", helper: "Payment terms", icon: CalendarDays },
    { id: "departments", label: "Departments", helper: "Vendor setup", icon: Building2 },
    { id: "expenseTypes", label: "Expense Types", helper: "Spend categories", icon: ReceiptText },
    { id: "incomeTypes", label: "Income Types", helper: "Ledger income", icon: CircleDollarSign },
    { id: "payment_terminals", label: "Payment Terminals", helper: "Terminal setup", icon: CreditCard },
    { id: "printers", label: "Printers", helper: "Receipt printing", icon: Printer },
    { id: "cash_drawers", label: "Cash Drawers", helper: "Register drawers", icon: Inbox },
    { id: "invoice_layout", label: "Invoice Layout", helper: "Print templates", icon: FileText },
  ];

  // Permission Groups management now lives on the Manage Users page
  // (/manage-users) instead of here, so it's easier to find alongside
  // the rest of team/user administration.
  const visibleSettingsTabs = settingsTabs;

  const handleGetMethod = async () => {
    setLoading(true);
    try {
      const response = await _Get("settingData");
      if (response && response.length > 0) {
        const {
          no_of_register,
          no_of_register_lottery,
          id,
          sales_tax_percentage,
          lottery_book_from_last_number,
          lottery_after_end_of_the_day,
        } = response[0];
        setNumberOfRegisters(no_of_register);
        setNumberOfLotteryRegisters(no_of_register_lottery);
        setSettingId(id); // Setting the settingId from the response
        setSalesTax(sales_tax_percentage); // Initial sales tax value
        setLotteryBookFromLastNumber(lottery_book_from_last_number ?? true);
        setLotteryAfterEndOfDay(lottery_after_end_of_the_day ?? true);
        setSelectedRegister(no_of_register);
        setSelectedLotteryRegister(no_of_register_lottery);
      }
    } catch (error) {
      console.error("Error fetching setting data:", error);
      // toast.error("Failed to load settings. Please try again.");
      handleToast({
        type: "ERROR",
        message: "Failed to load settings. Please try again",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePatchSalesTax = async (newSalesTaxValue) => {
    if (
      newSalesTaxValue !== undefined &&
      newSalesTaxValue !== null &&
      settingId
    ) {
      try {
        const payload = {
          store: storeId, // Ensure correct store ID is used
          sales_tax_percentage: newSalesTaxValue, // Send updated sales tax
          lottery_book_from_last_number: lotteryBookFromLastNumber,
          lottery_after_end_of_the_day: lotteryAfterEndOfDay,
        };

        const response = await Patch(`settingData`, settingId, payload); // Update setting data
        if (response) {
          // toast.success("Sales tax updated successfully!");
          handleToast({
            type: "SUCCESS",
            message: "Sales tax updated successfully!",
          });
        }
      } catch (error) {
        console.error("Error updating sales tax:", error);
        // toast.error("Failed to update sales tax. Please try again.");
        handleToast({
          type: "ERROR",
          message: "Failed to update sales tax. Please try again.",
        });
      }
    }
  };

  const handlePatchMethod = async (value) => {
    if (!settingId) {
      // toast.error("Setting ID is missing.");
      handleToast({
        type: "ERROR",
        message: "Setting ID is missing.",
      });
      return;
    }

    try {
      const payload = {
        store: storeId,
        no_of_register: value,
        lottery_book_from_last_number: lotteryBookFromLastNumber,
        lottery_after_end_of_the_day: lotteryAfterEndOfDay,
      };
      const response = await Patch(`settingData`, settingId, payload);
      if (response) {
        // toast.success("Register updated successfully!");
        handleToast({
          type: "SUCCESS",
          message: "Register updated successfully!",
        });
      }
    } catch (error) {
      console.error(
        "Error updating setting data:",
        error.response || error.message
      );
      // toast.error("Failed to update register. Please try again.");
      handleToast({
        type: "ERROR",
        message: "Failed to update register. Please try again.",
      });
    }
  };

  const handleToggleLotterySetting = async (value) => {
    if (!settingId) {
      // toast.error("Setting ID is missing.");
      handleToast({
        type: "ERROR",
        message: "Setting ID is missing.",
      });
      return;
    }
    try {
      const payload = {
        store: storeId,
        no_of_register_lottery: value, // This field can be customized based on your API requirements
        lottery_book_from_last_number: lotteryBookFromLastNumber,
        lottery_after_end_of_the_day: lotteryAfterEndOfDay,
      };
      const response = await Patch(`settingData`, settingId, payload);
      if (response) {
        // toast.success("Lottery setting updated successfully!");
        handleToast({
          type: "SUCCESS",
          message: "Lottery setting updated successfully!",
        });
      }
    } catch (error) {
      console.error(
        "Error updating lottery setting data:",
        error.response || error.message
      );
      // toast.error("Failed to update lottery setting. Please try again.");
      handleToast({
        type: "ERROR",
        message: "Failed to update lottery setting. Please try again.",
      });
    }
  };

  useEffect(() => {
    handleGetMethod();
  }, []);

  const handleIncrementSalesTax = async (event) => {
    const newSalesTaxValue = parseFloat(event.target.value);

    if (!isNaN(newSalesTaxValue)) {
      setSalesTax(newSalesTaxValue); // Update local state

      // Call the API to update the sales tax on the backend
      try {
        await handlePatchSalesTax(newSalesTaxValue); // Ensure this function is defined correctly
      } catch (error) {
        // toast.error("Failed to update sales tax");
        handleToast({
          type: "ERROR",
          message: "Failed to update sales tax.",
        });
      }
    } else {
      setSalesTax(""); // Optionally, handle invalid value input
      // toast.error("Invalid sales tax value.");
      handleToast({
        type: "ERROR",
        message: "Invalid sales tax value.",
      });
    }
  };

  const handleRegisterChange = (event) => {
    const valueToBeSelectedRegister = event.target.value;
    setSelectedRegister(valueToBeSelectedRegister);
    handlePatchMethod(valueToBeSelectedRegister);
  };

  const handleLotteryRegisterChange = (event) => {
    const valueToBeSelectedLotteryRegister = event.target.value;
    setSelectedLotteryRegister(valueToBeSelectedLotteryRegister);
    handleToggleLotterySetting(valueToBeSelectedLotteryRegister);
  };

  const handleLotteryBookFromLastNumberChange = async (checked) => {
    setLotteryBookFromLastNumber(checked);
    if (settingId) {
      try {
        const payload = {
          store: storeId,
          lottery_book_from_last_number: checked,
          lottery_after_end_of_the_day: lotteryAfterEndOfDay,
        };
        await Patch(`settingData`, settingId, payload);
        handleToast({
          type: "SUCCESS",
          message: "Lottery setting updated successfully!",
        });
      } catch (error) {
        handleToast({
          type: "ERROR",
          message: "Failed to update lottery setting.",
        });
      }
    }
  };

  const handleLotteryAfterEndOfDayChange = async (checked) => {
    setLotteryAfterEndOfDay(checked);
    if (settingId) {
      try {
        const payload = {
          store: storeId,
          lottery_book_from_last_number: lotteryBookFromLastNumber,
          lottery_after_end_of_the_day: checked,
        };
        await Patch(`settingData`, settingId, payload);
        handleToast({
          type: "SUCCESS",
          message: "Lottery setting updated successfully!",
        });
      } catch (error) {
        handleToast({
          type: "ERROR",
          message: "Failed to update lottery setting.",
        });
      }
    }
  };

  const handleShow = (type) => {
    setFormType(type);
    setShowModal(true);
  };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await GetPaginatedData("bank");
        setBanks(response.data); // Use paginated data array
      } catch (error) {
        console.error("Error fetching bank data", error);
        handleToast({
          type: "ERROR",
          message: "Error fetching bank data",
        });
      }
    };

    const fetchDueDays = async () => {
      try {
        const response = await GetPaginatedData("dueDaysData");
        const dueDaysData = response?.data || response?.rawResponse?.results || response?.rawResponse || [];
        setDueDaysList(Array.isArray(dueDaysData) ? dueDaysData : []);
      } catch (error) {
        console.error("Error fetching due days", error);
        handleToast({
          type: "ERROR",
          message: "Error fetching due days",
        });
      }
    };

    fetchBanks();
    fetchDueDays();
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setBankName("");
    setBankBranch("");
    setAccountNumber("");
    setEditingBankId(null);
    setDueDays("");
    setEditingDueDayId(null); // Reset branch on close
  };

  const isTextOnly = (value) => /^[A-Za-z\s]+$/.test(value);
  const isValidAccountNumber = (value) => /^\d{25}$/.test(value);

  const handleBankNameChange = (e) => {
    const value = capitalizeFirstLetter(e.target.value);
    if (value === "" || isTextOnly(value)) {
      setBankName(value);
    }
  };

  const handleBankBranchChange = (e) => {
    const value = capitalizeFirstLetter(e.target.value);
    if (value === "" || isTextOnly(value)) {
      setBankBranch(value);
    }
  };

  const handleAccountNumberChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,25}$/.test(value)) {
      setAccountNumber(value);
    }
  };

  const handleClearBankForm = () => {
    setBankName("");
    setBankBranch("");
    setAccountNumber("");
    setEditingBankId(null);
  };

  const staticRegisters = [
    { value: 1, label: "1" },
    { value: 2, label: "2" },
    { value: 3, label: "3" },
    { value: 4, label: "4" },
    { value: 5, label: "5" },
  ];

  const renderOptions = (selectedValue, numberOfRegisters) => (
    <>
      {staticRegisters.map((register) => (
        <option
          key={register.value}
          value={register.value}
          className="register-option"
        >
          {register.label}
        </option>
      ))}
    </>
  );

  const handleSaveBank = async () => {
    if (bankName && bankBranch && accountNumber && storeId) {
      try {
        const newBank = {
          name: bankName,
          branch: bankBranch,
          account_no: accountNumber,
          store: storeId,
        };

        if (editingBankId) {
          const response = await Put("bank", editingBankId, newBank);
          const bankData = response.data || response || { ...newBank, id: editingBankId };
          setBanks((prevBanks) =>
            prevBanks.map((bank) =>
              bank.id === editingBankId ? { ...bank, ...bankData, id: editingBankId } : bank
            )
          );
        } else {
          const response = await Post("bank", newBank);
          const bankData = response.data || response;
          setBanks((prevBanks) => [...prevBanks, bankData]);
        }

        handleToast({
          type: "SUCCESS",
          message: editingBankId ? "Bank updated successfully!" : "Bank added successfully!",
        });
        handleClose(); // Close the form/modal
      } catch (error) {
        console.error("Error saving bank", error);
        const backendMessage = error.response?.data?.message
          ? Array.isArray(error.response.data.message)
            ? error.response.data.message.join(", ")
            : error.response.data.message
          : "Error saving bank. Please try again.";

        handleToast({
          type: "ERROR",
          message: backendMessage,
        });
      }
    } else {
      // toast.warn("Please fill in all required fields.");
      handleToast({
        type: "WARNING",
        message: "Please fill in all required fields.",
      });
    }
  };

  const handleEditBank = (bank) => {
    setBankName(bank.name || "");
    setBankBranch(bank.branch || "");
    setAccountNumber(bank.account_no || bank.account_number || bank.accountNumber || "");
    setEditingBankId(bank.id);
    handleShow("bank");
  };

  const handleDeleteBank = async (bankId) => {
    const result = await confirmDelete();
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: "You won't be able to revert this!",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#d33",
    //   cancelButtonColor: "#3085d6",
    //   confirmButtonText: "Yes, delete it!",
    // });

    // Check if the user clicked the confirm button
    if (!result.isConfirmed) return; // Exit if the user cancels

    try {
      await Delete("bank", bankId);
      setBanks((prevBanks) => prevBanks.filter((bank) => bank.id !== bankId));
      // toast.success("Bank deleted successfully!");
      handleToast({
        type: "SUCCESS",
        message: "Bank deleted successfully!",
      });
    } catch (error) {
      console.error("Error deleting bank:", error);
      // toast.error("Error deleting bank. Please try again.");
      handleToast({
        type: "ERROR",
        message: "Error deleting bank. Please try again.",
      });
    }
  };

  const handleSaveDueDays = async () => {
    if (dueDays) {
      const newDueDay = { days: dueDays, store: storeId };
      try {
        if (editingDueDayId) {
          // Update existing due day
          await Put("dueDaysData", editingDueDayId, newDueDay);
          setDueDaysList((prevList) =>
            prevList.map((day) =>
              day.id === editingDueDayId
                ? { ...day, days: dueDays, store: storeId }
                : day
            )
          );

          // toast.success("Due day updated successfully!");
          handleToast({
            type: "SUCCESS",
            message: "Due day updated successfully!",
          });
        } else {
          const response = await Post("dueDaysData", newDueDay);

          // Ensure the response is correctly handled
          if (response) {
            // Get the actual response data, handling different response formats
            const createdDueDay = response.data || response;
            setDueDaysList((prevList) => [...prevList, createdDueDay]);
            // toast.success("Due day added successfully!");
            handleToast({
              type: "SUCCESS",
              message: "Due day added successfully!",
            });
          } else {
            // toast.error("Failed to retrieve the created due day data.");
            handleToast({
              type: "ERROR",
              message: "Failed to retrieve the created due day data.!",
            });
          }
        }
        handleClose();
      } catch (error) {
        console.error("Error adding or updating due day:", error);
        const backendMessage = error.response?.data?.message
          ? Array.isArray(error.response.data.message)
            ? error.response.data.message.join(", ")
            : error.response.data.message
          : "Error saving due day. Please try again.";

        handleToast({
          type: "ERROR",
          message: backendMessage,
        });
      }
    } else {
      // toast.warn("Due days value is required.");
      handleToast({
        type: "WARNING",
        message: "Due days value is required",
      });
    }
  };

  const handleEditDueDay = (day) => {
    setDueDays(day.days);
    setEditingDueDayId(day.id);
    handleShow("dueDays");
  };

  const handleDeleteDueDay = async (dayId) => {
    const result = await confirmDelete();
    // Swal.fire({
    //   title: "Are you sure?",
    //   text: "You won't be able to revert this!",
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#d33",
    //   cancelButtonColor: "#3085d6",
    //   confirmButtonText: "Yes, delete it!",
    // });

    // Check if the user clicked the confirm button
    if (!result.isConfirmed) return; // Exit if the user cancels
    try {
      await Delete("dueDaysData", dayId);
      setDueDaysList((prevList) => prevList.filter((day) => day.id !== dayId));
      // toast.success("Due day deleted successfully!");
      handleToast({
        type: "SUCCESS",
        message: "Due day deleted successfully!",
      });
    } catch (error) {
      console.error("Error deleting due day", error);
      // toast.error("Error deleting due day. Please try again.");
      handleToast({
        type: "ERROR",
        message: "Error deleting due day. Please try again.",
      });
    }
  };

  const columns = [{ header: "Store Vendor Name", field: "name" }];

  if (loading) {
    return (
      <LoadingOverlay loading={loading} loader={loader} />
    );
  }

  return (
    <>
      <ToastContainer />
      <div className="responsive-box settings-workspace-panel">
        <div className="settings-section-header">
          <div>
            <span className="settings-section-kicker">Store setup</span>
            <h2>Manage Settings</h2>
            <p>Manage store configuration, payment banks and invoice due-day presets from one clean workspace.</p>
          </div>
        </div>
        <div className="settings-tab-layout">
          <aside className="settings-vertical-tabs" aria-label="Manage settings sections">
            {visibleSettingsTabs.map((tab) => {
              const TabIcon = tab.icon;
              return (
              <button
                key={tab.id}
                type="button"
                className={`settings-vertical-tab ${activeSettingsTab === tab.id ? "active" : ""}`}
                onClick={() => setActiveSettingsTab(tab.id)}
              >
                <span className="settings-vertical-tab-icon">
                  <TabIcon size={18} />
                </span>
                <span className="settings-vertical-tab-copy">
                  <span className="settings-vertical-tab-label">{tab.label}</span>
                  <small className="settings-vertical-tab-helper">{tab.helper}</small>
                </span>
              </button>
              );
            })}
          </aside>

          <div className="settings-tab-content">
            {activeSettingsTab === "configuration" && (
              <div className="settings-tab-pane">
                <Configuration />
              </div>
            )}

            {activeSettingsTab === "banks" && (
          <section className="settings-detail-section">
            <div className="settings-subsection-header">
              <div>
                <span className="settings-section-kicker">Payout accounts</span>
                <h3>Manage Banks</h3>
                <p>Add and maintain bank accounts used for store deposits and reports.</p>
              </div>
              <button
                onClick={() => handleShow("bank")}
                className="settings-primary-action"
              >
                Add Bank
                <img
                  src={BankIcon}
                  alt="Bank Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>
            </div>

            <div className="settings-table-wrap">
              <table className="settings-data-table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Bank Name</th>
                    <th>Short Name</th>
                    <th>Account Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {banks.length > 0 ? banks.map((bank, index) => (
                    <tr key={bank.id || index}>
                      <td>{index + 1}</td>
                      <td>{bank.name || "-"}</td>
                      <td>{bank.branch || "-"}</td>
                      <td>{bank.account_no || bank.account_number || bank.accountNumber || "-"}</td>
                      <td>
                        <div className="settings-row-actions">
                          <button
                            type="button"
                            className="settings-icon-action"
                            onClick={() => handleEditBank(bank)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="settings-icon-action settings-danger-action"
                            onClick={() => handleDeleteBank(bank.id)}
                            aria-label={`Delete ${bank.name || "bank"}`}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr>
                      <td colSpan="5">
                        <div className="settings-empty-state settings-table-empty">
                          <strong>No banks added yet</strong>
                          <span>Add your first bank account to keep payout records organized.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
            )}

          <ReusableModal
            show={showModal && formType === "bank"}
            handleClose={handleClose}
            title={editingBankId ? "Update Bank" : "Add Bank"}
            width="600px"
          >
            <form>
              <div
                className="d-flex flex-column"
                style={{
                  marginLeft: "20px",
                  marginRight: "10px",
                  marginTop: "20px",
                }}
              >
                <div className="d-flex align-items-center mb-4 mx-3">
                  {/* Bank Name Input */}
                  <div
                    className="position-relative"
                    style={{ width: "300px", marginRight: "10px" }}
                  >
                    <input
                      type="text"
                      value={bankName}
                      className="form-control-setting"
                      onChange={handleBankNameChange}
                      placeholder=""
                    />
                    <label className="floating-label">Bank Name</label>
                  </div>

                  {/* Bank Short Name Input */}
                  <div
                    className="position-relative"
                    style={{ width: "300px", marginRight: "10px" }}
                  >
                    <input
                      type="text"
                      value={bankBranch}
                      onChange={handleBankBranchChange}
                      className="form-control-setting"
                      placeholder=""
                    />
                    <label className="floating-label">Bank Short Name</label>
                  </div>
                </div>

                <div className="d-flex align-items-center mb-4 mx-3">
                  {/* Account Number Input */}
                  <div
                    className="position-relative"
                    style={{ width: "300px", marginRight: "10px" }}
                  >
                    <input
                      type="number"
                      value={accountNumber}
                      onChange={handleAccountNumberChange}
                      className="form-control-setting"
                      placeholder=""
                    />
                    <label className="floating-label">Account Number</label>
                  </div>
                  <div
                    className="position-relative"
                    style={{ width: "300px", marginRight: "10px" }}
                  ></div>
                </div>
              </div>

              {/* Submit Button */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginRight: "10px",
                  marginBottom: "10px",
                  gap: "20px",
                }}
              >
                <button
                  onClick={handleClearBankForm}
                  type="button"
                  style={{
                    color: "#282E26",
                    backgroundColor: "#ffffff",
                    border: "0.5px solid #282E26",
                    borderRadius: "40px",
                    width: "130px",
                    height: "38px",
                    fontWeight: "bold",
                  }}
                >
                  Clear
                </button>
                <button
                  onClick={handleSaveBank}
                  type="button"
                  style={{
                    color: "#FFFFFF",
                    backgroundColor: "#282E26",
                    border: "0.5px solid #282E26",
                    borderRadius: "40px",
                    width: "130px",
                    height: "38px",
                    fontWeight: "bold",
                  }}
                >
                  {editingBankId ? "Update Bank" : "Add Bank"}
                </button>
              </div>
            </form>
          </ReusableModal>

            {activeSettingsTab === "dueDays" && (
          <section className="settings-detail-section">
            <div className="settings-subsection-header">
              <div>
                <span className="settings-section-kicker">Payment terms</span>
                <h3>Due Days</h3>
                <p>Define reusable payment due-day presets for invoices and customers.</p>
              </div>
              <button
                onClick={() => handleShow("dueDays")}
                className="settings-primary-action"
              >
                Add New
                <img
                  src={duedays}
                  alt="due days Icon"
                  style={{ width: "20px", height: "20px" }}
                />
              </button>
            </div>

            <div className="settings-chip-board">
              {(dueDaysList || []).length > 0 ? (
                (dueDaysList || []).map((day, index) => (
                  <div className="settings-config-chip" key={day.id || index}>
                    <span>
                      {day.days} day{Number(day.days) === 1 ? "" : "s"}
                    </span>
                    <button
                      type="button"
                      className="settings-chip-delete"
                      aria-label={`Delete ${day.days} due day preset`}
                      onClick={() => handleDeleteDueDay(day.id)}
                    >
                      <Trash2 size={14} />
                    </button>
                  </div>
                ))
              ) : (
                <div className="settings-empty-state settings-table-empty">
                  <strong>No due days added yet</strong>
                  <span>Add common payment terms like 7, 15 or 30 days.</span>
                </div>
              )}
            </div>
          </section>
            )}
          <ReusableModal
            show={showModal && formType === "dueDays"}
            handleClose={handleClose}
            title={editingDueDayId ? "Update Due Days" : "Add Due Days"}
            width="683px"
            height="230px"
          >
            <form>
              <div
                className="form-group mx-5"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginBottom: "20px",
                }}
              >
                {/* Input for Due Days */}
                <div style={{ position: "relative", marginBottom: "10px" }}>
                  <input
                    type="number"
                    value={dueDays}
                    onChange={(e) => setDueDays(e.target.value)}
                    className="form-control-setting"
                    placeholder=""
                  />
                  <label className="floating-label">Enter Due Days</label>
                </div>
              </div>

              {/* Buttons Section */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  marginRight: "10px",
                }}
              >
                {/* Save/Update Button */}
                <button
                  onClick={handleSaveDueDays}
                  type="button"
                  style={{
                    backgroundColor: "#282E26",
                    color: "white",
                    border: "none",
                    borderRadius: "40px",
                    cursor: "pointer",
                    width: "150px",
                    fontSize: "16px",
                    height: "38px",
                  }}
                >
                  {editingDueDayId ? "Update" : "Save"}
                </button>
              </div>
            </form>
          </ReusableModal>

            {activeSettingsTab === "departments" && (
          <section className="settings-detail-section settings-integrated-section">
            <div className="settings-subsection-header">
              <div>
                <span className="settings-section-kicker">Purchase setup</span>
                <h3>Departments For Vendors</h3>
                <p>Maintain vendor departments used while creating purchase bills, expenses and reports.</p>
              </div>
            </div>
            <ManageDepartments embedded />
          </section>
            )}

            {activeSettingsTab === "expenseTypes" && (
          <section className="settings-detail-section settings-integrated-section">
            <div className="settings-subsection-header">
              <div>
                <span className="settings-section-kicker">Spends setup</span>
                <h3>Expense Types</h3>
                <p>Manage reusable expense categories so store spending stays clean and reportable.</p>
              </div>
            </div>
            <ManageExpenseType embedded />
          </section>
            )}

            {activeSettingsTab === "incomeTypes" && (
          <section className="settings-detail-section settings-integrated-section">
            <div className="settings-subsection-header">
              <div>
                <span className="settings-section-kicker">Ledger setup</span>
                <h3>Other Income Types</h3>
                <p>Define non-sales income categories used in general ledger and business reports.</p>
              </div>
            </div>
            <OtherIncomeType embedded />
          </section>
            )}

            {activeSettingsTab === "payment_terminals" && (
              <PaymentTerminalSettings />
            )}

            {activeSettingsTab === "printers" && (
              <POSPrinterSettings />
            )}

            {activeSettingsTab === "cash_drawers" && (
              <POSCashDrawerSettings />
            )}

            {activeSettingsTab === "invoice_layout" && (
              <div className="settings-tab-pane">
                <InvoiceLayoutSettings />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default ManageSettings;
